import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Mascot from "@/components/Mascot";

const links = [
  { to: "/", label: "Home", testid: "nav-link-home" },
  { to: "/sell", label: "Sell Your Collection", testid: "nav-link-sell" },
  { to: "/marketplace", label: "Marketplace", testid: "nav-link-marketplace" },
  { to: "/contact", label: "Contact", testid: "nav-link-contact" },
];

const Nav = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-gold/20 bg-navy/85 backdrop-blur-xl" data-testid="site-nav">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 sm:px-8">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo" onClick={() => setOpen(false)}>
          <Mascot size={42} />
          <span className="font-display text-lg font-bold tracking-wide text-cream">
            Aardvarks <span className="text-gold">Vault</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.testid}
              className={({ isActive }) =>
                `font-mono text-[11px] uppercase tracking-[0.22em] transition-colors duration-200 ${
                  isActive ? "text-gold" : "text-cream/70 hover:text-cream"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/sell" state={{ scrollToForm: true }} className="btn-gold !px-5 !py-2.5" data-testid="nav-sell-button">
            Sell to the Vault
          </Link>
        </nav>

        <button
          className="text-cream lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
          data-testid="nav-mobile-toggle"
        >
          {open ? <Menu className="hidden" /> : null}
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-gold/15 bg-navy/95 px-6 pb-8 pt-4 backdrop-blur-xl lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-5">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`${l.testid}-mobile`}
                onClick={() => setOpen(false)}
                className={`font-mono text-xs uppercase tracking-[0.22em] ${
                  location.pathname === l.to ? "text-gold" : "text-cream/80"
                }`}
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/sell"
              state={{ scrollToForm: true }}
              onClick={() => setOpen(false)}
              className="btn-gold mt-2 w-fit"
              data-testid="nav-sell-button-mobile"
            >
              Sell to the Vault
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
